<template>
  <div>
    <div v-if="tramitando.background" class="vld-overlay is-active"
         style="z-index: 999; position: fixed; background: rgb(175 173 173 / 51%); backdrop-filter: blur(1px);"></div>
    <menu-pae :inFocus="false">
      <menu-processo :numeroProcesso="numeroProcesso" :apensado="apensado"/>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item">
                <router-link to="/workArea">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/elaboracao/consulta">Elaboração</router-link>
              </li>
              <li class="breadcrumb-item">Tramitar</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container mt-1">
      <alert-comp :key="msgKey" :msg="msgAlert">
        <hr v-if="processoSemDocumentoExterno.length != 0">
        <p class="mb-0" v-if="processoSemDocumentoExterno.length != 0"><strong>Protocolos sem documento</strong></p>
        <div v-if="processoSemDocumentoExterno.length != 0">
          <span
            v-for="numeroProtocolo in processoSemDocumentoExterno"
            :key="numeroProtocolo"
            class="badge badge-primary mr-1 text-white"
            @click="openDocumento(numeroProtocolo)"
            style="font-size: 12px !important; cursor: pointer;"
          >
            {{ formatarProtocolo(numeroProtocolo) }}
          </span>
        </div>
      </alert-comp>

      <alert-comp :center="true" v-if="tramitando.is" :key="tramitando.alertKey" :msg="tramitando.alert"
                  :dismissFunction="() => {return tramitando.background = false}">
        <div v-for="(processo, index) in processos" :key="processo.porcentagem">
          <span>{{ formatarProtocolo(processo.processo) }}</span> <span v-if="processo.status === 'danger'"
                                                                        class="badge badge-info link"
                                                                        @click="enviarNovamente(index)"> <i
          class="fa fa-refresh" aria-hidden="true"></i> Tramitar novamente</span>
          <progress-bar
            :key="`${processo.status}-${processo.porcentagem}`"
            :percentage="processo.porcentagem || '0%'"
            :danger="`bg-${processo.status}`"
            :warning="`bg-${processo.status}`"
            :success="`bg-${processo.status}`"
            :animated="true"
            class="mt-1 mb-3"
          />
        </div>
        <div class="col-12 text-right mb-2" v-if="tramitando.finished && processos.length !== tramitando.tramitados">
          <span class="badge badge-info text-left">Alguns protocolos não foram tramitados, logo não estarão dentro da Guia <br> Para aparecerem, tramite novamente os protocolos com erro</span>
        </div>
        <button class="btn btn-success" v-if="tramitando.finished" @click.prevent="gerarGuia"> Gerar Guia de
          Tramitação
        </button>
      </alert-comp>
    </div>

    <div class="container-md mt-2">
      <motivo-tramite-processo
        :processos="processos"
        :destinatarios="destinatarios"
        :eventBusDataName="eventBusDataNameEscolhido"
        :eventRemoverProcesso="eventRemoverProcesso"/>
    </div>

    <div class="container-md" v-show="!this.booleans.exibirTabelaDestinatarioEscolhido">
      <filtroInteressados
        :textError="textError"
        :eventBusDataName="eventRefresh"
        :dataTableColumn="dataTableColumn"
      />
    </div>

    <div class="container-md" v-show="this.booleans.exibirTabelaDestinatarioEscolhido">
      <data-table-consulta-comp
        :colNames="colNamesEscolhido"
        :eventBusDataName="eventBusDataNameEscolhido"
        :eventBusDataPaginationName="eventBusPaginationNameEscolhido">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important;">
            <i v-if="!tramitando.is" class="fa fa-times text-danger fa-1-5x" aria-hidden="true"
               v-on:click="remover(slotProps.itemData)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
      <div class="col" v-if="booleans.exibirBotaoTramitar">
        <label>Despacho:</label>
        <textarea v-if="!tramitando.is" class="form-control mb-1" v-model="despacho" rows="5" cols="40"></textarea>
        <div v-if="tramitando.is" class="form-control mb-1 w-100">{{ despacho }}</div>
        <div class="row btnAcoes" v-if="!tramitando.is">
          <button class="btn btn-success" @click.prevent="enviar"> {{ textoBotaoEnviar }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import menuProcesso from '@/components/MenuProcesso.vue'
import motivoTramiteProcesso from '@/components/tramite/MotivoTramiteProcesso'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import DataValues from '@/components/data-table-consulta/DataValues'
import eventBus from '@/uteis/eventBus'
import alertComp from '@/components/alert/AlertComp'
import filtroInteressados from '@/components/filtro-interessados/tramite'
import progressBar from '@/components/progressBar/ProgressBar'
import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

import DestinatarioService from '@/services/DestinatarioService'
import TramiteService from '@/services/TramiteService'
import VirtusService from '@/services/VirtusService'
import VirtusRepositoryService from '@/services/VirtusRepositoryService'

import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  name: 'tramitar',

  components: {
    menuPae,
    menuProcesso,
    motivoTramiteProcesso,
    dataTableConsultaComp,
    alertComp,
    filtroInteressados,
    progressBar
  },

  computed: {
    msgAlert () {
      return {
        type: this.textError === '' ? '' : 'danger',
        texto: this.textError === '' ? '' : this.textError
      }
    }
  },

  data () {
    return {
      textoBotaoEnviar: '',
      processoSemDocumentoExterno: [],
      textError: '',
      msgKey: false,
      tipoDestinatarios: [{
        tipoDestinatario: 'Poder Executivo Estadual'
      }, {
        tipoDestinatario: 'Poder Publico'
      }, {
        tipoDestinatario: 'Pessoa Juridica'
      }, {
        tipoDestinatario: 'Pessoa Fisica'
      }],
      parametros: {
        tipoDestinatario: 'Poder Executivo Estadual',
        descricaoLabel: 'Insira o CPF/Nome'
      },
      booleans: {
        exibirPoderExecutivo: true,
        exibirInteressados: false,
        exibirTabelaDestinatario: true,
        exibirTabelaDestinatarioEscolhido: false,
        exibirTabelaProcessosMotivos: false,
        exibirBotaoTramitar: false
      },
      colNames: ['Nome Estrutura', 'Sigla Estrutura', 'Descricao do Setor', 'Nome Gestor', 'Ações'],
      dataTableColumn: ['nomeEstrutura', 'siglaEstrutura', 'descricaoDoSetor', 'nomeUsuario'],
      colNamesEscolhido: ['Remetente', 'Destinatario', 'Tipo Destinatario', 'Ações'],
      dataTableColumnEscolhido: {
        PODEREXECUTIVO: ['remetente', 'destinatario', 'tipoDestinatario'],
        interessados: ['siglaDepartamentoRemetente', 'nome', 'tipoDestinatario']
      },
      eventBusDataName: 'consultaDestinários',
      eventBusDataNameEscolhido: 'consultaDestináriosEscolhido',
      eventRefresh: 'refreshConsultaDestinatario',
      eventBusPaginationName: 'consultaDestináriosDataPagination',
      eventBusPaginationNameEscolhido: 'consultaDestináriosDataPaginationEscolhido',
      eventBusLimparAutoCompleteInteressados: 'limparAutoCompleteInteressados',
      eventRemoverProcesso: 'removerProcesso',
      url: '/d0593/pae-back/v1/interessadosApi/interessados',
      destinatario: null,
      processos: [],
      destinatarios: {},
      despacho: '',
      lote: '',
      remetente: {},
      tramitando: {
        is: false,
        background: false,
        finished: false,
        length: 0,
        tramitados: 0,
        alertKey: false,
        alert: {
          type: 'light',
          texto: 'Tramitando os protocolos:'
        }
      }
    }
  },
  methods: {
    onChangeTipoDestinatario (event) {
      this.booleans = {
        exibirPoderExecutivo: false,
        exibirInteressados: false,
        exibirTabelaDestinatario: false,
        exibirTabelaDestinatarioEscolhido: this.booleans.exibirTabelaDestinatarioEscolhido
      }
      this.limparAutoCompleteInteressados()

      if (event.target.value) {
        switch (event.target.value) {
        case 'Pessoa Fisica':
          this.pessoaFisicaSelecionado()
          break
        case 'Pessoa Juridica':
          this.pessoaJuridicaSelecionado()
          break
        case 'Poder Executivo Estadual':
          this.poderExecutivoSelecionado()
          break
        case 'Poder Publico':
          this.pessoaJuridicaSelecionado()
          break
        default:
          this.poderExecutivoSelecionado()
          break
        }
      } else {
        this.poderExecutivoSelecionado()
      }
    },

    poderExecutivoSelecionado () {
      this.booleans.exibirPoderExecutivo = true
      this.booleans.exibirTabelaDestinatario = true
      this.verificarDestinatario()
    },

    pessoaFisicaSelecionado () {
      this.booleans.exibirInteressados = true
      this.parametros.descricaoLabel = 'Insira o CPF/Nome'
    },

    pessoaJuridicaSelecionado () {
      this.booleans.exibirInteressados = true
      this.parametros.descricaoLabel = 'Insira o CNPJ/Nome'
    },

    limparAutoCompleteInteressados () {
      eventBus.$emit(this.eventBusLimparAutoCompleteInteressados)
    },

    async remover (obj) {
      this.service.excluirDestinatario(obj.id).then(() => {
        this.booleans.exibirTabelaDestinatario = true
        this.booleans.exibirTabelaDestinatarioEscolhido = false
        this.destinatario = null
      })
    },

    getDataTableColumn (tipoDestinatario) {
      if (!this.dataTableColumnEscolhido[tipoDestinatario]) {
        return this.dataTableColumnEscolhido.interessados
      }

      return this.dataTableColumnEscolhido[tipoDestinatario]
    },

    async verificarDestinatario () {
      try {
        let destinatario = null
        for (const processo of this.processos) {
          const numeroProcesso = processo.processo
          const response = await this.service.buscarDestinatario(numeroProcesso)
          const existeDestinatario = response.data.length

          if (existeDestinatario === 1) {
            const data = response.data
            data[0].numeroProcesso = numeroProcesso

            this.destinatarios[numeroProcesso] = data[0]
            destinatario = data[0]
          }
        }
        if (destinatario) {
          const numeroPagina = 1
          const rowsNumber = 10

          const data = [{
            ...destinatario,
            remetente: `${destinatario.siglaDepartamentoRemetente} - ${destinatario.descricaoDepartamentoRemetente}`,
            destinatario: `${destinatario.siglaDepartamentoDestinatario} - ${destinatario.descricaoDepartamentoDestinatario}`
          }]
          const dataValues = new DataValues(data, numeroPagina, rowsNumber)
          dataValues.dataTableColumn = this.getDataTableColumn(destinatario.tipoDestinatario)

          eventBus.$emit(this.eventBusDataNameEscolhido, dataValues)
        }
      } catch (error) {
        console.log(error)
        this.textError = 'Erro ao carregar os destinarios'
      }
    },

    setDestinatario (data) {
      this.destinatario = data[0]

      this.$set(this.destinatarios, data[0].numeroProcesso, data[0])
    },

    async enviarNovamente (index) {
      var dadosSessao = this.dadosSessao.sessao
      var motivosProcessos = this.$store.state.motivosProcessos
      var destinatario = this.destinatarios[this.processos[0].processo]

      var processo = this.processos[index]
      var numeroProcesso = processo.processo
      var descricaoMotivo = motivosProcessos[numeroProcesso].data.descricaoMotivo

      this.tramitando.alertKey = !this.tramitando.alertKey
      this.processos[index] = {
        ...processo,
        status: 'info',
        porcentagem: '50%'
      }
      try {
        await this.service.tramitar([{
          numero: numeroProcesso,
          motivo: descricaoMotivo
        }], dadosSessao, destinatario, this.remetente, this.despacho, this.lote)
        this.processos[index] = {
          ...processo,
          status: 'success',
          porcentagem: '100%'
        }
        this.tramitando.alertKey = !this.tramitando.alertKey
        this.tramitando.tramitados++
      } catch (error) {
        console.log(error)
        this.processos[index] = {
          ...processo,
          status: 'danger',
          porcentagem: '100%'
        }
        this.tramitando.alertKey = !this.tramitando.alertKey
      }
    },

    async enviar () {
      var dadosSessao = this.dadosSessao.sessao
      var motivosProcessos = this.$store.state.motivosProcessos
      if (this.validaMotivosProcessoAtoEnvio(motivosProcessos)) {
        return
      }
      var destinatario = this.destinatarios[this.processos[0].processo]
      var processosTramitados = 0
      var despacho = this.despacho

      this.virtusService.getNumeroLote(dadosSessao).then((lote) => {
        const numeroLote = lote.data[0]
        this.lote = numeroLote

        const parametros = {
          codHierarquia: dadosSessao.codigoHierarquia
        }
        this.service.buscarDepartamento(parametros).then(async (response) => {
          console.log('data', response.data.data[0])
          const remetente = {
            cidade: response.data.data[0].cidade,
            estado: response.data.data[0].estado,
            telefone: response.data.data[0].telefone,
            logradouroRemetente: response.data.data[0].logradouro,
            bairroRemetente: response.data.data[0].bairro,
            cepRemetente: response.data.data[0].cep,
            numeroRemetente: response.data.data[0].numero,
            complementoRemetente: response.data.data[0].complemento || ''
          }
          this.remetente = remetente

          this.tramitando.is = true
          this.tramitando.background = true
          this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
            menu: false
          })
          for (var index in this.processos) {
            var processo = this.processos[index]
            var numeroProcesso = processo.processo
            var descricaoMotivo = motivosProcessos[numeroProcesso].data.descricaoMotivo

            this.tramitando.alertKey = !this.tramitando.alertKey
            this.processos[index] = {
              ...processo,
              status: 'info',
              porcentagem: '50%'
            }
            try {
              await this.service.tramitar([{
                numero: numeroProcesso,
                motivo: descricaoMotivo
              }], dadosSessao, destinatario, remetente, despacho, numeroLote)
              await this.service.excluirDestinatario(numeroProcesso)
              this.processos[index] = {
                ...processo,
                status: 'success',
                porcentagem: '100%'
              }
              this.tramitando.alertKey = !this.tramitando.alertKey
              processosTramitados++
            } catch (error) {
              console.log(error)
              this.processos[index] = {
                ...processo,
                status: 'danger',
                porcentagem: '100%'
              }
              this.tramitando.alertKey = !this.tramitando.alertKey
            }
          }

          this.tramitando.tramitados = processosTramitados
          this.tramitando.finished = true
        })
      })
    },

    async existeDocumentoExterno (numeroProcesso) {
      this.virtusService.existeDocumentoExterno(numeroProcesso).then((resp) => {
        if (!resp) {
          this.textError = 'Antes de tramitar, o usuário deve fazer o registro do documento no Ícone “incluir documento”'
          this.processoSemDocumentoExterno.push(numeroProcesso)
          this.booleans.exibirBotaoTramitar = false
          this.msgKey = !this.msgKey
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    checkDocumento () {
      this.textError = ''
      this.booleans.exibirBotaoTramitar = true
      this.processoSemDocumentoExterno = []
      for (var index in this.processos) {
        var processo = this.processos[index]
        var numeroProcesso = processo.processo
        this.existeDocumentoExterno(numeroProcesso)
      }
    },

    openDocumento (numeroProtocolo) {
      this.$store.commit('MUT_DOCUMENTO', { numeroProtocolo })
      this.$router.push({ path: `/elaboracao/${numeroProtocolo}/documento` })
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    },

    gerarGuia () {
      this.virtusRepositoryService.dowloadGuiTramite(this.lote).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' })

        var filename = `guia${this.lote}.pdf`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob)
        } else {
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL, filename)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    validaMotivosProcessoAtoEnvio (processosAtoEnvio) {
      let flag = false
      Object.keys(processosAtoEnvio).forEach((key) => {
        if (processosAtoEnvio[key].data.descricaoMotivo === 'SELECIONE UM MOTIVO') {
          this.textError = 'Obrigatório selecionar “Motivo da Tramitação” em todos os protocolos'
          this.msgKey = !this.msgKey
          flag = true
        }
      })
      return flag
    }
  },
  created () {
    this.service = new DestinatarioService()
    this.tramiteService = new TramiteService()
    this.virtusService = new VirtusService()
    this.virtusRepositoryService = new VirtusRepositoryService()

    this.apensado = this.$route.query.apensado
    this.dadosSessao = this.$store.getters.getDadosSessao

    const { DISTRIBUIR_PROTOCOLO, EXPEDIR_PROTOCOLO } = rules
    if (componentIsVisible(DISTRIBUIR_PROTOCOLO)) {
      this.textoBotaoEnviar = 'Distribuir / Tramitar'
    }

    if (componentIsVisible(EXPEDIR_PROTOCOLO)) {
      this.textoBotaoEnviar = 'Expedir / Distribuir'
    }

    if (this.$route.query.numeroProcesso) {
      // Caso seja a tramitação de um único processo
      this.numeroProcesso = this.$route.query.numeroProcesso
      this.processos = [{
        processo: this.numeroProcesso
      }]
    } else {
      // Caso seja da tramitação em lote
      var numerosProcesso = this.$store.getters.getProcessosTramitacao
      // Limpando o store
      this.$store.commit('MUT_PROCESSOS_TRAMITACAO', [])
      // Pegamos apenas o destinatário do primeiro processo
      // Já que todos possuem o mesmo destinatário
      this.numeroProcesso = numerosProcesso[0]
      for (var i = 0; i < numerosProcesso.length; ++i) {
        this.processos[i] = {
          processo: numerosProcesso[i]
        }
      }
    }

    this.verificarDestinatario()

    eventBus.$on(this.eventRefresh, (err) => {
      if (err) {
        this.textError = err.text
        this.msgKey = !this.msgKey
        return
      }
      this.booleans.exibirTabelaDestinatario = false
      this.booleans.exibirTabelaDestinatarioEscolhido = true
      this.verificarDestinatario()
    })

    eventBus.$on(this.eventBusDataNameEscolhido, (dataValues) => {
      this.booleans.exibirTabelaDestinatario = false
      this.booleans.exibirTabelaDestinatarioEscolhido = true
      this.setDestinatario(dataValues.data)
    })

    eventBus.$on(this.eventRemoverProcesso, async (numeroProcesso) => {
      delete this.destinatarios[numeroProcesso]
      let processos = this.processos
      processos = processos.filter((processo) => processo.processo !== numeroProcesso)
      this.processos = processos
    })
  },

  watch: {
    'booleans.exibirTabelaDestinatarioEscolhido': function () {
      if (this.booleans.exibirTabelaDestinatarioEscolhido) {
        this.msgAlert = {
          type: '',
          texto: ''
        }
        this.checkDocumento()
      }
    }
  },

  destroyed () {
    this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {})
    eventBus.$off(this.eventBusDataNameEscolhido)
    eventBus.$off(this.eventRefresh)
    eventBus.$off(this.eventRemoverProcesso)
  }
}
</script>

<style scoped>

</style>
